import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * A detail page's active tab, kept in the URL (?tab=contacts) so refresh,
 * Back and a shared link all land on the same tab. The default tab has no
 * parameter. Tab changes replace history rather than push it, so Back still
 * leaves the page instead of walking through tabs.
 *
 * @param {string} defaultTab
 * @param {string[]} [validTabs] - anything else in the URL falls back to the default
 * @returns {[string, Function]} like useState
 */
export default function useTabParam(defaultTab, validTabs) {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('tab');
  const tab = raw && (!validTabs || validTabs.includes(raw)) ? raw : defaultTab;

  const setTab = useCallback((next) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (!next || next === defaultTab) params.delete('tab');
      else params.set('tab', next);
      return params;
    }, { replace: true });
  }, [setSearchParams, defaultTab]);

  return [tab, setTab];
}
